import { render, staticRenderFns } from "./expressDes.vue?vue&type=template&id=35b2565c&scoped=true&"
import script from "./expressDes.vue?vue&type=script&lang=js&"
export * from "./expressDes.vue?vue&type=script&lang=js&"
import style0 from "./expressDes.vue?vue&type=style&index=0&id=35b2565c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2565c",
  null
  
)

export default component.exports